module.exports = __webpack_public_path__ + "static/img/zdhf04.23a0340.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/zdhf04.png
// module id = 121
// module chunks = 0